import { Hardware } from 'api';
import * as actions from './actionTypes';

export const getHardware = () => ({
	type: actions.GET_HARDWARE,
});

export const getHardwareSuccess = (payload: Hardware[]) => ({
	type: actions.GET_HARDWARE_SUCCESS,
	payload,
});

export const getHardwareError = (payload: string) => ({
	type: actions.GET_HARDWARE_ERROR,
	payload,
});

export const getHardwareForTariff = (tariffId?: string | number) => ({
	type: actions.GET_HARDWARE_FOR_TARIFF,
	payload: tariffId,
});
